import { createContext, useContext } from 'react';
import {
  useDetailWorkbenchActions,
  type UseDetailWorkbenchActionsOptions,
  type UseDetailWorkbenchActionsResult,
} from '../../hooks/workbench/useDetailWorkbenchActions';

export const DetailWorkbenchActionsContext = createContext<UseDetailWorkbenchActionsResult | null>(
  null
);

/**
 * Uses provider context when present; otherwise falls back to a local hook call.
 * When context exists, the fallback hook stays disabled to avoid duplicate CR4.
 */
export function useDetailWorkbenchActionsFromContext(
  options: UseDetailWorkbenchActionsOptions
): UseDetailWorkbenchActionsResult {
  const contextValue = useContext(DetailWorkbenchActionsContext);
  const hookResult = useDetailWorkbenchActions({
    ...options,
    enabled: contextValue !== null ? false : (options.enabled ?? true),
  });
  return contextValue ?? hookResult;
}

export function useDetailWorkbenchActionsContextOptional(): UseDetailWorkbenchActionsResult | null {
  return useContext(DetailWorkbenchActionsContext);
}
